import React from "react";
import KioskShopDetailContentSkeleton from "./skeleton/KioskShopDetailContentSkeleton";
import ScrollContent from "components/UI/ScrollContent";
import styles from "./KioskShopDetailContent.module.css";
import placeholder360x225 from "assets/placeholder/360x225.png";
import placeholder1000x625 from "assets/placeholder/1000x625.png";

const KioskShopDetailContent = ({ details, loading, floorName, slot }) => {
  if (loading || !details) {
    return <KioskShopDetailContentSkeleton />;
  }

  return (
    <div className={styles.Detail}>
      <div className={styles.TitleRow}>
        <h2 className={styles.Title}> {details.title}</h2>
        {floorName && slot && (
          <div className={styles.Slot}>
            {floorName} - {slot}
          </div>
        )}
      </div>

      <div className={styles.DetailBox}>
        <ScrollContent mr={32}>
          <img
            src={details.logo || placeholder360x225}
            alt="shop-logo"
            className={styles.Logo}
          />
          <img
            src={details.thumb || placeholder1000x625}
            alt={details.title}
            className={styles.Thumbnail}
          />
          <div
            className={styles.Content}
            dangerouslySetInnerHTML={{ __html: details.content }}
          ></div>
        </ScrollContent>
      </div>
    </div>
  );
};

export default KioskShopDetailContent;
